<template>
  <div>
    <v-card>
      <v-tabs v-model="tab" background-color="primary" dark>
        <v-tab>Comprobante</v-tab>
        <v-tab>Productos</v-tab>
      </v-tabs>
      <v-card-text>
        <form>
          <v-tabs-items v-model="tab">
            <v-tab-item>
              <v-alert type="info" v-if="pedido">
                Orden # {{ pedido._id.slice(-5) }} generada el
                {{
                  $moment(pedido.fechaAlta).format(
                    "dddd DD [de] MMMM YYYY H:mm"
                  )
                }}
                <v-icon @click="verPedido()">mdi-eye</v-icon>
              </v-alert>
              <v-row>
                <v-col cols="4">
                  <v-autocomplete
                    v-model="venta.comprobante.tipo"
                    :items="tipo_comprobante"
                    hide-no-data
                    label="Tipo de Comprobante"
                    :error-messages="errorTipoComprobante"
                    @input="$v.venta.comprobante.tipo.$touch()"
                    @blur="$v.venta.comprobante.tipo.$touch()"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="8">
                  <v-skeleton-loader
                    v-if="loadingClientes"
                    type="chip"
                  ></v-skeleton-loader>
                  <v-autocomplete
                    v-else
                    v-model="venta.cliente"
                    :items="clientes"
                    hide-no-data
                    label="Cliente"
                    item-text="nombre"
                    return-object
                    :error-messages="errorCliente"
                    @input="$v.venta.cliente.$touch()"
                    @blur="$v.venta.cliente.$touch()"
                    @change="verCliente"
                    append-outer-icon="mdi-account-plus"
                    @click:append-outer="nuevoCliente = true"
                  ></v-autocomplete>
                  <v-card class="mx-auto" outlined v-if="cliente._id != ''">
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>
                          {{ cliente.tipo_responsable.descripcion }}
                          {{ cliente.documento.tipo.descripcion }}
                          {{ cliente.documento.numero }}
                        </v-list-item-title>
                        <v-list-item-subtitle>
                          <v-combobox
                            v-model="venta.direccion"
                            :items="venta.cliente.direcciones"
                            label="Direccion de Facturacion"
                            item-text="value"
                            item-value="value"
                          ></v-combobox>
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-card>
                </v-col>
              </v-row>
            </v-tab-item>
            <v-tab-item>
              <v-skeleton-loader
                v-if="loadingProductos"
                type="table"
              ></v-skeleton-loader>

              <div v-else>
                <v-row>
                  <v-col cols="6">
                    <v-text-field
                      v-model="buscadorProductos"
                      append-icon="mdi-magnify"
                      ref="buscadorProductos"
                      label="Buscar producto"
                      @keyup.enter="seleccionarPrimerProducto"
                      @keyup.esc="borrarBusquedaProducto"
                      @keyup.112="guardarVenta"
                      single-line
                      hide-details
                    ></v-text-field>
                    <v-data-table
                      :headers="encProductos"
                      :search="buscadorProductos"
                      :items="productos"
                      :options="optProductos"
                      sort-by="codigo"
                      class="elevation-1"
                      @click:row="agregarProducto"
                      @current-items="itemsFiltradosProductos"
                    >
                      <template v-slot:[`item.precio`]="{ item }">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <span v-bind="attrs" v-on="on"
                              >$ {{ item.precio }}</span
                            >
                          </template>
                          <span v-if="item.precios.length > 1">
                            <ul class="fa-ul">
                              <li
                                v-for="precio in item.precios"
                                :key="precio._id"
                              >
                                {{ precio.cantidad }}+ $ {{ precio.precio }}
                              </li>
                            </ul>
                          </span>
                          <span v-else>Precio unico</span>
                        </v-tooltip></template
                      >
                    </v-data-table>
                  </v-col>

                  <v-col cols="6">
                    <v-simple-table>
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th class="text-left">Producto</th>
                            <th class="text-left">Cantidad</th>
                            <th class="text-left">Monto</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="item in venta.productos"
                            :key="item.producto"
                          >
                            <td>{{ item.nombre }}</td>
                            <td>{{ item.cantidad }}</td>
                            <td>$ {{ item.precio_total }}</td>
                            <td>
                              <v-icon
                                small
                                class="mr-2"
                                @click="editarProducto(item)"
                                >mdi-pencil</v-icon
                              >
                              <v-icon
                                small
                                class="mr-2"
                                @click="borrarProducto(item)"
                                >mdi-delete</v-icon
                              >
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                    <span v-if="$v.venta.productos.$invalid"
                      >Debe ingresar al menos un producto.</span
                    >
                    <v-simple-table>
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th class="text-left">Subtotal</th>
                            <th class="text-left">Descuento</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>
                              <v-text-field
                                v-model="venta.subtotal"
                                readonly
                                prefix="$"
                              ></v-text-field>
                            </td>
                            <td>
                              <v-text-field
                                v-model="venta.descuento"
                                prefix="$"
                                :error-messages="errorDescuento"
                                @input="$v.venta.descuento.$touch()"
                                @blur="$v.venta.descuento.$touch()"
                              ></v-text-field>
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                    <v-simple-table v-if="restantePago > 0">
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th class="text-left">Medios de Pago</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>
                              <v-chip
                                class="ma-2"
                                color="green"
                                text-color="white"
                                @click="medioPago('EFECTIVO')"
                              >
                                <v-avatar left>
                                  <v-icon>mdi-cash</v-icon> </v-avatar
                                >Efectivo
                              </v-chip>
                              <v-chip
                                class="ma-2"
                                color="indigo"
                                text-color="white"
                                @click="medioPago('MERCADO PAGO')"
                              >
                                <v-avatar left>
                                  <v-icon>mdi-nfc</v-icon> </v-avatar
                                >Mercado Pago
                              </v-chip>
                              <v-chip
                                class="ma-2"
                                color="blue"
                                text-color="white"
                                @click="medioPago('POSNET')"
                              >
                                <v-avatar left>
                                  <v-icon
                                    >mdi-credit-card-wireless</v-icon
                                  > </v-avatar
                                >POSNET
                              </v-chip>
                              <v-chip
                                class="ma-2"
                                color="red"
                                text-color="white"
                                @click="medioPago('TRANSF. BANCARIA')"
                              >
                                <v-avatar left>
                                  <v-icon>mdi-bank</v-icon> </v-avatar
                                >Transf. Bancaria
                              </v-chip>
                              <v-chip
                                class="ma-2"
                                color="indigo"
                                text-color="white"
                                @click="medioPago('DEPOSITO BANCARIO')"
                              >
                                <v-avatar left>
                                  <v-icon>mdi-bank</v-icon> </v-avatar
                                >Deposito Bancario
                              </v-chip>
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                    <v-simple-table v-if="venta.medios_pago.length > 0">
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th class="text-left">Medio</th>
                            <th class="text-left">Recargo</th>
                            <th class="text-left">Abonado</th>
                            <th class="text-left">Vuelto</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(item, index) in venta.medios_pago"
                            :key="index"
                          >
                            <td>
                              <v-icon
                                small
                                class="mr-2"
                                @click="quitarMedioPago(item)"
                                >mdi-delete</v-icon
                              >
                              {{ item.medio }} {{ item.comprobante }}
                            </td>
                            <td>$ {{ item.recargo }}</td>
                            <td>$ {{ item.monto }}</td>
                            <td>$ {{ item.vuelto }}</td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                    <v-dialog
                      v-model="ventanaMedioPago"
                      persistent
                      max-width="290"
                    >
                      <v-card>
                        <v-card-title class="headline"
                          >A PAGAR $ {{ restantePago }}</v-card-title
                        >
                        <v-card-text>
                          <v-text-field
                            v-model="medio_pago.monto"
                            prefix="$"
                            label="Monto"
                            ref="montoPago"
                            type="number"
                            @input="verificarMonto()"
                          ></v-text-field>
                          <div v-if="medio_pago.medio != 'EFECTIVO'">
                            <v-select
                              :items="listaRecargos"
                              label="Recargo"
                              v-model="medioPagoRecargoPorcentual"
                            ></v-select>
                            <v-text-field
                              v-model="medio_pago.comprobante"
                              label="Comprobante"
                            ></v-text-field>
                            <v-simple-table>
                              <template v-slot:default>
                                <thead>
                                  <tr>
                                    <th class="text-left">Recargo</th>
                                    <th class="text-left">Total</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td>$ {{ recargoMedio }}</td>
                                    <td>$ {{ totalMedio }}</td>
                                  </tr>
                                </tbody>
                              </template>
                            </v-simple-table>
                          </div>
                          <v-simple-table v-else>
                            <template v-slot:default>
                              <thead>
                                <tr>
                                  <th class="text-left">Vuelto</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td>$ {{ vueltoEfectivo }}</td>
                                </tr>
                              </tbody>
                            </template>
                          </v-simple-table>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            color="red darken-1"
                            text
                            @click="ventanaMedioPago = false"
                            >Cancelar</v-btn
                          >
                          <v-btn
                            color="green darken-1"
                            text
                            @click="guardarMedioPago()"
                            >Aceptar</v-btn
                          >
                        </v-card-actions>
                      </v-card>
                    </v-dialog>

                    <v-simple-table>
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th class="text-left">Total</th>
                            <th class="text-left">Restante a Abonar</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>
                              <h3>
                                $
                                {{ precioTotal }}
                              </h3>
                            </td>
                            <td>
                              $
                              {{ restantePago }}
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-col>
                </v-row>
              </div>
            </v-tab-item>
          </v-tabs-items>
          <v-divider></v-divider>
          <v-btn
            class="ma-2"
            block
            :color="$v.venta.$invalid ? 'warning' : 'success'"
            @click="guardarVenta()"
            :loading="loadingFormulario"
          >
            <v-icon left>
              {{
                $v.venta.$invalid ? "mdi-alert-circle-outline" : "mdi-check"
              }} </v-icon
            >Cobrar Venta
          </v-btn>
          <v-btn
            class="ma-2"
            dark
            block
            color="blue"
            @click="generarPresupuesto()"
          >
            <v-icon left>mdi-file</v-icon>Generar Presupuesto
          </v-btn>
          <v-btn class="ma-2" block color="error" @click="_cerrar()">
            <v-icon left>mdi-close</v-icon>Cancelar
          </v-btn>
        </form>
      </v-card-text>
    </v-card>
    <v-dialog v-model="loadingFiscal" persistent max-width="290">
      <v-card>
        <v-card-text class="text-center">
          <p class="font-weight-black">
            Guardando venta...
          </p>
          <v-progress-circular
            indeterminate
            color="primary"
          ></v-progress-circular>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="loadingPresupuesto" persistent max-width="290">
      <v-card>
        <v-card-text class="text-center">
          <p class="font-weight-black">Guardando Presupuesto</p>
          <v-progress-circular
            indeterminate
            color="primary"
          ></v-progress-circular>
        </v-card-text>
      </v-card>
    </v-dialog>
    <NuevoCliente v-model="nuevoCliente" @seleccionarCliente="seleccionarCliente" @nuevoCliente="seleccionarNuevoCliente"/>
  </div>
</template>
<script>
import axios from "axios";
import { required, minLength } from "vuelidate/lib/validators";
import { saveAs } from "file-saver";
import NuevoCliente from "../../components/NuevoCliente"
const greaterEqThanZero = (value) => value >= 0;
const isTrue = (value) => value === true;
export default {
  name: "Mercaderias_Nuevo",
  components: {
    NuevoCliente
  },
  data() {
    return {
      nuevoCliente: false,
      tab: 1,
      venta: {
        cliente: "",
        comprobante: {
          tipo: "",
          codigo: "",
          numero: "",
          pdf: "",
        },
        direccion: "",
        productos: [],
        subtotal: 0,
        descuento: 0,
        recargo: 0,
        total: 0,
        medios_pago: [],
        abonado: false,
      },
      producto: {
        producto: "",
        nombre: "",
        cantidad: 0,
        precio_unitario: 0,
        precio_total: 0,
        codigo: "",
        iva: 0,
      },
      clientes: [],
      cliente: {
        _id: "",
        nombre: "",
        documento: {
          tipo: "",
          numero: "",
        },
        tipo_responsable: "",
        direccion: "",
      },
      tipo_comprobante: ["PRESUPUESTO", "FACTURA"],
      medio_pago: {
        medio: "",
        monto: 0,
        recargo: 0,
        vuelto: 0,
        comprobante: "",
      },
      medioPagoRecargoPorcentual: 0,
      productos: [],
      encProductos: [
        {
          text: "Codigo",
          align: "start",
          value: "codigo",
        },
        { text: "Nombre", value: "nombre" },
        { text: "Categoria", value: "categoria.nombre" },
        { text: "Precio", value: "precio" },
        { text: "Stock", value: "stock" },
      ],
      optProductos: {
        itemsPerPage: 5,
      },
      pedido: null,
      buscadorProductos: "",
      productosFiltrados: [],
      productoIndexSeleccionado: 0,
      loadingClientes: true,
      loadingProductos: true,
      loadingFiscal: false,
      ventanaMedioPago: false,
      loadingFormulario: true,
      loadingPresupuesto: false,
    };
  },
  methods: {
    async seleccionarNuevoCliente(_id) {
      this.loadingClientes = true
      const clientes = await axios.get("/personas/cliente");
      this.clientes = clientes.data;
      this.seleccionarCliente(_id)
      this.loadingClientes = false
    },
    seleccionarCliente(_id) {
      this.venta.cliente = this.clientes.find(v => v._id == _id)
      this.verCliente(this.venta.cliente)
    },
    async generarPresupuesto() {
      if (this.venta.productos.length > 0) {
        const guardar = confirm("¿Desea guardar este presupuesto?");

        try {
          if (guardar) {
            this.loadingPresupuesto = true;
            const presupuesto = await axios.post(
              "/presupuestos/nuevo",
              this.venta
            );
            this.loadingPresupuesto = false;
            if (!presupuesto.data._id) {
              throw "No se pudo guardar el presupuesto.";
            }
          }
          const Comprobante = await axios.post(
            "/ventas/fe",
            {
              ...this.venta,
              comprobante: { tipo: "PRESUPUESTO" },
              noGuardarPdf: true,
            },
            { responseType: "blob" }
          );
          let blob = new Blob([Comprobante.data], { type: "application/pdf" });
          saveAs(
            blob,
            `PRESUPUESTO-${this.venta.cliente.nombre}-${this.$moment(
              new Date()
            ).format("DD-MM-YYYY")}.pdf`
          );
        } catch (e) {
          alert(e);
        }
      }
    },
    async guardarVenta() {
      if (this.venta.medios_pago.length == 0 && this.restantePago > 0) {
        if (confirm("¿Considerar como venta en efectivo?")) {
          this.venta.medios_pago.push({
            medio: "EFECTIVO",
            monto: this.restantePago,
            recargo: 0,
            vuelto: 0,
            comprobante: "",
          });
          this.venta.abonado = true;
        }
      }
      this.$v.venta.$touch();
      if (!this.$v.venta.$invalid && !this.loadingFormulario) {
        try {
          if (confirm("¿Confirmar venta?")) {
            this.loadingFormulario = true;

            const Comprobante = await this.generarFacturaFiscal();
            if (!Comprobante)
              throw {
                error:
                  "No se pudo generar el comprobante. Por favor, reintente.",
              };

            this.venta.comprobante = Comprobante;

            if (this.pedido) this.venta.pedido = this.pedido._id;
            const venta = await axios.post("/ventas/nuevo", this.venta);
            if (!venta)
              throw {
                error: "No se pudo guardar la venta. Intente nuevamente.",
              };

            let id = venta.data;
            this.$router.push({
              name: "Ventas_Ver",
              params: { id, nuevaVenta: true },
            });
          }
        } catch (e) {
          alert(e.error);
          this.loadingFormulario = false;
        }
      }
    },
    async generarFacturaFiscal() {
      this.loadingFiscal = true;
      try {
        const Factura = await axios.post("/ventas/fe", this.venta);
        this.loadingFiscal = false;
        return Factura.data;
      } catch (error) {
        console.log(error);
        this.loadingFiscal = false;
        return false;
      }
    },
    seleccionarPrimerProducto() {
      this.agregarProducto(this.productosFiltrados[0]);
      this.buscadorProductos = "";
    },
    borrarBusquedaProducto() {
      this.buscadorProductos = "";
    },
    encontrarPrecio(item, cantidad) {
      return item.precios.reduce(
        (obj, p) => {
          if (cantidad >= p.cantidad) obj = p;
          return obj;
        },
        { precio: 0, cantidad: 0 }
      ).precio;
    },
    agregarProducto(item) {
      let cantidad = prompt("Ingrese cantidad de " + item.nombre, 1);
      if (cantidad) {
        cantidad = parseFloat(cantidad);
        if (!isNaN(cantidad) && cantidad > 0) {
          const found = this.venta.productos.find(
            (el) => el.producto === item._id
          );

          if (found) {
            let index = this.venta.productos.indexOf(found);
            let suma = this.venta.productos[index].cantidad + cantidad;
            if (suma <= item.stock) {
              this.venta.productos[index].cantidad = suma;
              this.venta.productos[index].precio_total =
                suma * this.encontrarPrecio(item, suma);
            } else {
              alert("Stock insuficiente.");
            }
          } else {
            if (cantidad <= item.stock) {
              let precio = this.encontrarPrecio(item, cantidad);
              this.venta.productos.push({
                producto: item._id,
                nombre: item.nombre,
                cantidad,
                precios: item.precios,
                precio_unitario: precio,
                precio_total: precio * cantidad,
                codigo: item.codigo,
                iva: item.iva,
                stock: item.stock,
              });
            } else {
              alert("Stock insuficiente.");
            }
          }
        } else {
          alert("Debe ingresar una cantidad mayor a cero.");
        }
      }
    },
    editarProducto(item) {
      let cantidad = prompt(
        "Ingrese cantidad de " + item.nombre,
        item.cantidad
      );
      if (cantidad) {
        cantidad = parseFloat(cantidad);
        if (!isNaN(cantidad) && cantidad > 0) {
          let index = this.venta.productos.indexOf(item);
          if (this.venta.productos[index].stock >= cantidad) {
            this.venta.productos[index].cantidad = cantidad;
            this.venta.productos[index].precio_total =
              this.encontrarPrecio(item, cantidad) * cantidad;
          } else {
            alert("Stock insuficiente.");
          }
        } else {
          alert("Debe ingresar una cantidad mayor a cero.");
        }
      }
    },
    verCliente(cliente) {
      this.cliente = cliente;
      this.cliente.direcciones.forEach((element, index) => {
        let direccion = element.direccion_1;
        if (element.direccion_2 != "") direccion += ` ${element.direccion_2}`;
        direccion += `, ${element.ciudad.nombre}, ${element.provincia.nombre} (CP: ${element.cp})`;
        this.cliente.direcciones[index].value = direccion;
      });
      this.venta.direccion = this.cliente.direcciones[0].value;
    },
    borrarProducto(item) {
      if (confirm("¿Quitar el producto " + item.nombre + "?")) {
        let index = this.venta.productos.indexOf(item);
        this.venta.productos.splice(index, 1);
      }
    },
    medioPago(medio) {
      this.medio_pago = {
        medio,
        monto: 0,
        recargo: 0,
        vuelto: 0,
        comprobante: "",
      };
      this.medioPagoRecargoPorcentual = this.listaRecargos[0].value;
      this.ventanaMedioPago = true;
      setTimeout((x) => {
        this.$nextTick(() => this.$refs.montoPago.focus());
      }, 500);
    },
    guardarMedioPago() {
      if (!isNaN(this.medio_pago.monto) && this.medio_pago.monto > 0) {
        if (this.medio_pago.medio === "EFECTIVO") {
          const found = this.venta.medios_pago.find(
            (el) => el.medio === this.medio_pago.medio
          );
          this.medio_pago.vuelto = this.vueltoEfectivo;
          if (found) {
            let index = this.venta.medios_pago.indexOf(found);
            this.venta.medios_pago[index].monto += this.medio_pago.monto;
            this.venta.medios_pago[index].vuelto = this.medio_pago.vuelto;
            this.venta.medios_pago[index].recargo = parseFloat(
              this.venta.medios_pago[index].recargo + this.medio_pago.recargo
            ).toFixed(2);
          } else {
            this.venta.medios_pago.push(this.medio_pago);
          }
        } else {
          this.medio_pago.recargo = this.recargoMedio;
          this.medio_pago.monto = this.totalMedio;
          this.venta.medios_pago.push(this.medio_pago);
        }
        this.ventanaMedioPago = false;
      } else {
        alert("Ingrese un monto correcto.");
      }
    },
    verificarMonto() {
      this.medio_pago.monto = parseFloat(this.medio_pago.monto);
      if (isNaN(this.medio_pago.monto) || this.medio_pago.monto < 0)
        this.medio_pago.monto = 0;
      if (
        this.medio_pago.medio != "EFECTIVO" &&
        this.medio_pago.monto > this.restantePago
      )
        this.medio_pago.monto = this.restantePago;
    },
    quitarMedioPago(item) {
      if (
        confirm(
          "¿Remover el pago en " + item.medio + " por $ " + item.monto + " ?"
        )
      ) {
        let index = this.venta.medios_pago.indexOf(item);
        this.venta.medios_pago.splice(index, 1);
      }
    },
    itemsFiltradosProductos(items) {
      this.productosFiltrados = items;
    },
    verPedido() {
      if (this.pedido) this.$router.push(`/pedido/${this.pedido._id}`);
    },
    _cerrar() {
      if (confirm("¿Cancelar operación actual?")) {
        this.$router.push(`/ventas`);
      }
    },
  },
  validations: {
    venta: {
      comprobante: {
        tipo: { required },
      },
      cliente: { required },
      productos: { required },
      medios_pago: { required },
      descuento: { required, greaterEqThanZero },
      abonado: { isTrue },
    },
  },
  async created() {
    try {
      const arqueo = await axios.get('/arqueos/ultArqueo')
      if(arqueo.data.aging > 0) {
        alert(`El ultimo Arqueo de Caja fue realizado el ${arqueo.data.fecha} (hace ${arqueo.data.aging} dia(s)). Si no es correcto, realice un Arqueo de Caja antes de efectuar una nueva venta.`)
      }
      this.venta.comprobante.tipo = "PRESUPUESTO";
      const clientes = await axios.get("/personas/cliente");
      this.clientes = clientes.data;
      const cf = this.clientes.find((el) => el.nombre === "CONSUMIDOR FINAL");
      if (cf) {
        this.venta.cliente = cf;
        this.verCliente(cf);
      }
      this.loadingClientes = false;
      const productos = await axios.get("/productos");
      this.productos = productos.data;
      this.loadingProductos = false;
      if (this.$route.params.presupuesto) {
        let cl = this.clientes.find(
          (el) =>
            el.nombre === this.$route.params.presupuesto.cliente.nombre ||
            el._id === this.$route.params.presupuesto.cliente._id
        );
        if (cl) {
          this.venta.cliente = cl;
          this.verCliente(cl);
        }
        this.$route.params.presupuesto.productos.forEach((el) => {
          let p = this.productos.find((e) => e._id === el.producto._id);
          if (p) {
            if (el.cantidad <= p.stock) {
              let producto = {
                producto: p._id,
                nombre: p.nombre,
                cantidad: el.cantidad,
                precio_unitario: p.precio,
                precio_total: p.precio * el.cantidad,
                codigo: p.codigo,
                iva: p.iva,
              };
              this.venta.productos.push(producto);
            } else {
              alert(
                `Ya no hay suficiente stock de ${p.nombre}. Cantidad solicitada: ${el.cantidad}, stock actual: ${p.stock}`
              );
            }
          }
        });
      }
      if (this.$route.params.pedido) this.pedido = this.$route.params.pedido;
      this.loadingFormulario = false;
      setTimeout((x) => {
        this.$nextTick(() => this.$refs.buscadorProductos.focus());
      }, 500);
    } catch (error) {
      console.log(error);
    }
  },
  computed: {
    listaRecargos() {
      let array = [];
      switch (this.medio_pago.medio) {
        case "MERCADO PAGO":
          array = [
            {
              text: "MERCADO PAGO ENVIO DE DINERO 0%",
              value: 0,
            },
            {
              text: "QR DINERO EN CUENTA/DEBITO 1.76%",
              value: 1.76,
            },
            {
              text: "QR CREDITO / LINK EFECTIVO O DEBITO 8.99%",
              value: 8.99,
            },
            {
              text: "POINT DEBITO 5.51%",
              value: 5.51,
            },
            {
              text: "POINT / LINK CREDITO 12.67%",
              value: 12.67,
            },
          ];
          break;
        case "POSNET":
          array = [
            {
              text: "DEBITO 1%",
              value: 1,
            },
          ];
          break;
        case "TRANSF. BANCARIA":
          array = [
            {
              text: "SIN COMISION",
              value: 0,
            },
          ];
          break;
        default:
          array = [
            {
              text: "SIN COMISION",
              value: 0,
            },
          ];
          break;
      }
      return array;
    },
    precioTotal() {
      let precioSub = 0;
      this.venta.productos.forEach((element) => {
        precioSub += element.precio_total;
      });
      this.venta.subtotal = precioSub;
      if (isNaN(this.venta.descuento) || this.venta.descuento < 0)
        this.venta.descuento = 0;
      this.venta.total =
        precioSub +
        parseFloat(this.venta.recargo) -
        parseFloat(this.venta.descuento);
      return this.venta.total;
    },
    restantePago() {
      let pagos = 0.0;
      this.venta.recargo = 0.0;
      this.venta.medios_pago.forEach((element) => {
        this.venta.recargo = parseFloat(
          this.venta.recargo + element.recargo
        ).toFixed(2);
        pagos += element.monto;
      });
      pagos = parseFloat(this.venta.total).toFixed(2) - pagos;
      pagos = pagos > 0 ? pagos : 0;
      this.venta.abonado = pagos === 0 ? true : false;
      return parseFloat(pagos);
    },
    vueltoEfectivo() {
      let vuelto = this.medio_pago.monto - this.restantePago;
      if (vuelto < 0) vuelto = 0;
      return vuelto;
    },
    recargoMedio() {
      return parseFloat(
        this.medio_pago.monto * (this.medioPagoRecargoPorcentual / 100)
      ).toFixed(2);
    },
    totalMedio() {
      return parseFloat(this.medio_pago.monto) + parseFloat(this.recargoMedio);
    },
    errorCliente() {
      const errors = [];
      if (!this.$v.venta.cliente.$dirty) return errors;
      !this.$v.venta.cliente.required &&
        errors.push("Debe seleccionar un Cliente.");
      return errors;
    },
    errorTipoComprobante() {
      const errors = [];
      if (!this.$v.venta.comprobante.tipo.$dirty) return errors;
      !this.$v.venta.comprobante.tipo.required &&
        errors.push("Debe seleccionar un Tipo de Comprobante.");
      return errors;
    },
    errorDescuento() {
      const errors = [];
      if (!this.$v.venta.descuento.$dirty) return errors;
      !this.$v.venta.descuento.required &&
        errors.push("Debe ingresar un monto de descuento (al menos $ 0).");
      !this.$v.venta.descuento.greaterEqThanZero &&
        errors.push("Debe ingresar un numero mayor o igual a cero.");
      return errors;
    },
  },
};
</script>
